import type { ArticleCard } from "$lib/types/shared";

type opt = {
  sveltekitServerFetch?: typeof fetch;
  last?: number;
  category?: "Nyheter" | "Sparetips" | "Fremhevet";
};

// NOTE: `last` can not be sent to endpoint since endpoint is SSG including possibly unpublished articles
export const fetchArticles = async (opt: opt): Promise<ArticleCard[]> => {
  const { sveltekitServerFetch, last } = opt;
  const category = opt?.category || "";
  const apiUrl = !category
    ? `/api/privat/artikler`
    : `/api/privat/artikler/${category.toLowerCase()}`;

  const res = sveltekitServerFetch ? await sveltekitServerFetch(apiUrl) : await fetch(apiUrl);

  // Return articles with not future publishedAt
  if (res.ok) {
    const data = await res.json();
    const articles: ArticleCard[] = data.articles;

    const items = articles.filter((article) => {
      const publishedAt = new Date(article.publishedAt);
      const now = new Date();
      return publishedAt <= now;
    });

    return last ? items.slice(0, last) : items;
  }

  return [];
};
